function intiBundleDeal( )
{
    document.addEventListener( "click", function( e )
    {
        if ( e.target.matches( ".bundle-deal-atc" ) )
        {
            var inQuickAdd = false;
            if ( e.target.parentElement.parentElement.matches( ".quick-add__content" ) )
            {
                var inQuickAdd = true;
            }
            var input = document.querySelector( ".bundle-label .bundle-input:checked" );
            var itemQuantity = input.getAttribute( "value" );
            var variantId = input.dataset.variant;
            if ( variantId )
            {
                let formData =
                {
                    'items': 
                    [
                        {
                            'id': variantId,
                            'quantity': itemQuantity
                        }
                    ]
                };
                
                fetch( window.Shopify.routes.root + 'cart/add.js',
                    {
                        method: 'POST',
                        headers:
                        {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify( formData )
                    })
                .then( response =>
                {
                    const cartDrawer = document.querySelector( 'cart-drawer' );
                    const quickAdd = document.querySelector( 'quick-add-drawer' );
                    if ( inQuickAdd === true )
                    {
                        quickAdd.addedToCart( );
                        cartDrawer.refresh( true );
                    }
                    else
                    {
                        cartDrawer.refresh( true );
                        cartDrawer.open( );
                    }
                    
                    return response.json();
                })
                .catch( ( error ) =>
                {
                    console.error( 'Error:', error );
                });
            }
            else
            {
                console.log( "No variant attribute, unable to add to cart." );
            }
        }
    } );
}

intiBundleDeal( );